import React, { Fragment } from 'react';
import { bool, func } from 'prop-types';
import { required, length } from 'redux-form-validators';

import { Form, Divider, Button, Input } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import CommonForm from '~/views/common/Form';


const CreateFeatureFlag = ({
    submitting,
    pristine,
    invalid,
    ...rest
}) => (
    <Fragment>
        <Divider />
        <CommonForm submitting={submitting} {...rest}>
            <Form.Group>
                <FormField
                    control={Input}
                    name="name"
                    label="Name"
                    placeholder="Name"
                    validate={[required(), length({ min: 5, max: 40 })]}
                    required
                />
                <FormField
                    control={Input}
                    name="description"
                    label="Description"
                    placeholder="Description"
                    width={8}
                />
            </Form.Group>

            <Button
                type="submit"
                disabled={pristine || submitting || invalid}
                loading={submitting}
                content="Create"
                primary
            />
        </CommonForm>
    </Fragment>
);

CreateFeatureFlag.propTypes = {
    submit: func.isRequired,
    submitting: bool.isRequired,
    pristine: bool.isRequired,
    invalid: bool.isRequired,
};

export default CreateFeatureFlag;
